import React, { useState, useEffect } from 'react';
import '../ScrollToTop/scrollToBtnUp.css';

const ScrollToTop = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div>
      {' '}
      {showTopBtn && (
        <button id="scrollToBtnUp" title="Вернуться наверх" onClick={goToTop}>
          <span></span>
        </button>
      )}
    </div>
  );
};
export default ScrollToTop;
